@use "stylesheets/utility/variables";

.ceremonyRegister {
  width: 100%;
  max-width: 450px;

  @media (max-width: variables.$mobileL) {
    padding-top: 20px;
  }
  @media (min-width: variables.$tablet) and (max-width: variables.$laptop) {
    padding-top: 40px;
  }
}

.formWrapper {
  margin-left: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.formHeadline {
  margin: 15px;
}

.infoHeadline {
  font-size: 16px;
  margin: 20px 0 5px 15px;
}

h5.capitalizedHeader {
  padding: 20px 0;
  margin: 0 0 0 15px;
  font-weight: 400;
}

.registerButton {
  width: 100%;
  margin: 15px 0 70px 0;
}

.alerts {
  margin: 0 20px;
  padding-bottom: 20px;
}
